import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface QuizDirRoom {
  code: string;
  hostName: string;
  playerCount: number;
  phase: string;
  updatedAt: number;
}

/** Quizzle landing — host (big screen) or join (tap an open game, or type a code). */
export function QuizzleEntry() {
  const nav = useNavigate();
  const [joining, setJoining] = useState(false);
  const [code, setCode] = useState("");
  const [rooms, setRooms] = useState<QuizDirRoom[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!joining) return;
    let alive = true;
    const load = () => {
      setLoading(true);
      fetch("/quiz/rooms")
        .then((r) => r.json() as Promise<{ rooms?: QuizDirRoom[] }>)
        .then((d) => { if (alive) setRooms(Array.isArray(d.rooms) ? d.rooms : []); })
        .catch(() => {})
        .finally(() => { if (alive) setLoading(false); });
    };
    load();
    const id = window.setInterval(load, 3000);
    return () => { alive = false; window.clearInterval(id); };
  }, [joining]);

  const join = (c: string) => {
    const up = c.trim().toUpperCase();
    if (up.length >= 3) nav(`/quizzle/play?code=${up}`);
  };

  return (
    <div className="quizzle-entry">
      <h1 className="quizzle-entry-title">🧩 Quizzle</h1>
      <p className="quizzle-entry-sub">Classroom quiz — host on the big screen, everyone plays on their iPads.</p>
      {!joining ? (
        <div className="quizzle-entry-actions">
          <button className="btn btn-green btn-big btn-block" onClick={() => nav("/quizzle/host")}>🖥️ Host on this screen</button>
          <button className="btn btn-blue btn-big btn-block" onClick={() => setJoining(true)}>📱 Join a game</button>
          <button className="btn btn-ghost" onClick={() => nav("/")}>← Menu</button>
        </div>
      ) : (
        <div className="quizzle-entry-actions">
          <div className="quizzle-join-list">
            {rooms.length === 0 && <p className="quizzle-dim">{loading ? "Looking for games…" : "No open games right now."}</p>}
            {rooms.map((r) => (
              <button key={r.code} className="quizzle-join-room" onClick={() => join(r.code)}>
                <span className="quizzle-join-room-code">{r.code}</span>
                <span className="quizzle-join-room-meta">
                  <strong>{r.hostName}'s game</strong>
                  <small>{r.playerCount} {r.playerCount === 1 ? "player" : "players"} waiting</small>
                </span>
                <span className="quizzle-join-room-go" aria-hidden>▶</span>
              </button>
            ))}
          </div>
          <div className="quizzle-join-or">or enter a code</div>
          <form className="quizzle-join-codeform" onSubmit={(e) => { e.preventDefault(); join(code); }}>
            <input
              className="quizzle-code-input"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              placeholder="CODE"
              maxLength={6}
              inputMode="text"
              aria-label="Room code"
            />
            <button className="btn btn-green btn-big btn-block" type="submit" disabled={code.trim().length < 3}>Join</button>
          </form>
          <button className="btn btn-ghost" onClick={() => setJoining(false)}>← Back</button>
        </div>
      )}
    </div>
  );
}
